import { useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import Header, { type HeaderTone } from './Header'
import Footer from './Footer'

/** Pages whose first section is white, so the header needs black text. */
const DARK_HEADER_PATHS = ['/store', '/register', '/api-docs']

function ScrollToTop() {
  const { pathname } = useLocation()
  useEffect(() => {
    try {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' })
    } catch {
      /* not available in test environments */
    }
  }, [pathname])
  return null
}

export default function Layout() {
  const { pathname } = useLocation()
  const tone: HeaderTone = DARK_HEADER_PATHS.some((p) => pathname.startsWith(p)) ? 'dark' : 'light'
  return (
    <div className="relative flex min-h-svh flex-col">
      <ScrollToTop />
      <Header tone={tone} />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  )
}
